import { useState, useEffect, Fragment } from "react"
import ImvEditImages from "./assets/_editImvImages"
import { EditIcon } from "../../assets/icons"
import EditImv from "../../../services/EditImv"
import { Transition, Dialog } from "@headlessui/react"
import { ImvFieldData } from "./assets/ImvFieldData"
import { useMutation } from "react-query"
import { DeleteImv } from "../../../services/DeleteImv"
import { ImvDeleteConfirmModal } from "./assets/[modal]imvDeleteConfirm"

export const ImvEditModal = ({ imv, isOpen, onClose }) => {
    const [isConfirmOpen, setIsConfirmOpen] = useState(false) //* Estado do Modal de confirmação | Deletar Imovel
    const [activeSec, setActiveSec] = useState('dados')
    const [fieldData, setFieldData] = useState()

    useEffect(() => {
        setFieldData(imv)
    }, [imv])

    const { mutate, data, error } = useMutation(EditImv)

    useEffect(() => {
        console.log('Cadastro de Imovel Alterado: ', data)
    }, [data])

    const handleSubmitEdit = () => {
        const nreg = imv.nreg
        try {
            // const response = EditImv(nreg, fieldData)
            mutate({ nreg, fieldData })
        } catch (error) {
            console.error('Erro ao Editar: ', error)
        }
        onClose()
        console.log(`Imovel ${imv.nreg} Editado`)
    }

    const handleIsActive = (e) => {
        setFieldData((prevData) => ({
            ...prevData,
            is_active: e.target.checked
        }));
    }

    const handleClose = () => {
        setIsConfirmOpen(false)
    }

    const handleDelete = (nreg) => { //! Abre o modal de Confimação para Deletar
        setIsConfirmOpen(true)
    }

    const selectorClasses = 'w-1/4 p-2 text-center rounded-xl bg-[#1ea7e64d] cursor-pointer hover:bg-[#4d75c5]'
    const activeClasses = 'w-1/4 p-2 text-center border bg-[#1d4ba7] cursor-pointer rounded-full hover:bg-[#1d4ba7]'

    return (<>
        {/* Modal de Confirmação de exclusão do imovel */}
        <ImvDeleteConfirmModal isOpen={isConfirmOpen} onClose={handleClose} nreg={imv?.nreg} />

        <Transition appear show={isOpen}>
            <Dialog as="div" className="relative z-10" onClose={() => onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-[#0004]" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">


                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-2/3 max-md:w-full transform border shadow-[inset_0_0_2rem_#fff2] overflow-hidden rounded-2xl bg-[#5a83d469] backdrop-blur-lg text-white p-6 text-left align-middle transition-all">
                                <Dialog.Title as="h3" className="text-lg mb-5 text-center font-medium leading-6 text-white">
                                    Editar Cadastro do {`Nº${imv?.nreg}`}
                                </Dialog.Title>

                                {/* Formulario */}
                                <form className="grid w-full text-white gap-y-5">
                                    {/* page selector */}
                                    <div className="flex justify-around items-stretch w-full">
                                        <div onClick={() => setActiveSec('dados')} className={`${activeSec === 'dados' ? (activeClasses) : ''} ${selectorClasses}`}> Dados </div>
                                        <div onClick={() => setActiveSec('fotos')} className={`${activeSec === 'fotos' ? (activeClasses) : ''} ${selectorClasses}`}> Fotos </div>
                                    </div>

                                    {activeSec === 'dados' ? (

                                        <ImvMetadata imv={imv} fieldData={fieldData} isActiveState={fieldData?.is_active} setFieldData={setFieldData} handleIsActive={handleIsActive} />

                                    ) : <div className="h-full p-10">
                                        <h2 className="text-center"> em {imv.end} </h2>

                                        <ImvEditImages nreg={imv.nreg} />

                                    </div>}

                                    <details about="Imovel Ativo?">Imóveis Ativos são exibidos nas paginas de anuncios e pesquisa </details>

                                    <footer className="flex gap-x-3 justify-stretch">
                                        <div className="bg-[red] w-1/6 p-3 text-center cursor-pointer rounded-lg" onClick={() => onClose(false)}> Fechar </div>
                                        <div className="bg-[#2a7e35] w-full p-3 text-center cursor-pointer rounded-lg" onClick={() => handleSubmitEdit()}> Enviar </div>
                                        <div className="bg-[red] w-2/6 p-3 text-center cursor-pointer rounded-lg" onClick={() => handleDelete(imv.nreg)}> Deletar Imóvel </div>
                                    </footer>
                                </form>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    </>)
}

const ImvMetadata = ({ fieldData, isActiveState, setFieldData, handleIsActive }) => { //* Renderiza on inputs de dados do Imovel
    return (<>
        {/* Fields Wrapper */}
        <div className="grid grid-cols-2 gap-5 p-">
            {Object.keys(ImvFieldData).map((field, index) => (
                <>
                    <fieldset key={index} className="flex w-full h-10 border rounded-sm">
                        <EditIcon />
                        <label className="flex items-center w-1/2" htmlFor={field}> {ImvFieldData[field]?.label} </label>

                        <input className="rounded-sm w-1/2 px-5 from-[#5654ad] to-[#1d4aa7] bg-gradient-to-br"
                            onChange={(e) => setFieldData((prevData) => ({ ...prevData, [field]: e.target.value }))}
                            value={fieldData[field]}
                            {...fieldData[field]?.name === 'acc_anim'}
                            type={ImvFieldData[field]?.type} name="" id=""
                        />
                    </fieldset>
                </>
            ))}

            {/* Imovel Ativo? Checkbox */}
            <fieldset className="flex gap-4">
                <label htmlFor="is_active"> Imóvel Ativo:
                </label>
                <input onChange={(e) => handleIsActive(e)} className="w-10 opacity"
                    type="checkbox" name="is_ative" id="" checked={isActiveState} />

            </fieldset>
        </div>
    </>)
}